import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  SUPERVISOR,
  USK_PRE_ACCEPTANCE,
} from 'consts';
import { ROLE_ROUTES_PERMISSIONS } from 'consts/permissions/routes';

import { Profile } from 'types';

export const useHasRole = (profile: Profile, path: string) => {
  const { role } = profile;

  switch (role) {
    case COMMERCIAL:
    case ENGINEERING_NETWORKS:
    case FURNISHING_SUPERVISOR:
    case HEAD_EN:
    case HEAD_OVP:
    case OBSERVER:
    case PARTNER:
    case PLANNER:
    case PRIME_CONTRACTOR:
    case HOUSING_CONTRACTOR:
    case SUPERVISOR:
    case USK_PRE_ACCEPTANCE:
      return ROLE_ROUTES_PERMISSIONS[role].some(route => route === path);
    default:
      return false;
  }
};
